<template>
  <div>
    <h3 class="h3-responsive">Xэрэглэгчийн бүртгэл жагсаалт</h3>
    <Toast position="bottom-right" />

    <!-- configration dialog -->
    <Dialog
      header="Анхааруулга"
      :visible.sync="displayDelete"
      :style="{ width: '505px' }"
      :modal="true"
    >
      <template #header></template>
      <div class="confirmation-content">
        <i
          class="pi pi-exclamation-triangle p-mr-3"
          style="font-size: 2rem; margin-right: 0.5em; color: red"
        />
        <span
          >Та {{ this.userId }} дугаартай хэрэглэгчийг үйлчилгээг устгахдаа
          итгэлтэй байна уу ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          @click="actionDialog('no', null)"
          class="p-button-danger p-button-text"
        />
        <Button
          label="Тийм"
          icon="pi pi-check"
          @click="actionDialog('yes', null)"
          class="p-button-danger p-button-text"
          autofocus
        />
      </template>
    </Dialog>
    <!-- diaglog for register and update contract -->
    <Dialog
      :visible.sync="displayModal"
      :style="{ width: '70vw' }"
      :modal="true"
    >
      <template #header>
        <div class="p-grid">
          <div class="p-col-8">
            <h3 class="h3-responsive">{{ modalTitle }}</h3>
          </div>
          <div class="p-col-4">
            <div class="form-group">
              <label for="selectedContractId">Хамаарах гэрээний дугаар:</label>
              <Dropdown
                id="selectedContractId"
                class="form-control"
                placeholder="Гэрээний дугаар сонгоно уу"
                v-model="selectedContractId"
                optionLabel="Id"
                :options="contractIds"
                :class="{
                  'is-invalid': $v.selectedContractId.$error,
                  'is-valid': !$v.selectedContractId.$invalid,
                }"
                :disabled="contractDisabled == 1"
                :autofocus="IsFocus"
                :style="{ height: '50px' }"
              />
              <div class="valid-feedback">Гэрээний дугаар сонгосон!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.selectedContractId.required"
                  >Гэрээний дугаар сонгоно уу.
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="p-grid">
        <div class="p-col">
          <h5 class="h5-responsive">Хэрэглэгчийн мэдээлэл:</h5>
          <div class="p-fluid p-formgrid p-grid">
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="username">Нэр:</label>
              <InputText
                id="username"
                type="text"
                class="form-control"
                v-model.trim="$v.username.$model"
                :class="{
                  'is-invalid': $v.username.$error,
                  'is-valid': !$v.username.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">Нэр оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.username.required"> Нэр оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="password">Нууц үг:</label>
              <InputText
                id="password"
                type="text"
                class="form-control"
                v-model.trim="$v.password.$model"
                :class="{
                  'is-invalid': $v.password.$error,
                  'is-valid': !$v.password.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">Нууц үг оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.password.required"> Нууц үг оруулна уу.</span>
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="selectedType">Системийн эрх:</label>
              <Dropdown
                v-model="selectedType"
                :options="typeItems"
                :showClear="true"
                optionLabel="name"
                placeholder="Системийн эрх сонгоно уу"
                :class="{
                  'is-invalid': $v.selectedType.$error,
                  'is-valid': !$v.selectedType.$invalid,
                }"
                :disabled="disabled == 1"
              >
              </Dropdown>
              <div class="valid-feedback">Системийн эрх оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.selectedType.required"
                  >Системийн эрх сонгоно уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="registerNumber">Регистрийн дугаар:</label>
              <InputText
                id="registerNumber"
                type="text"
                class="form-control"
                v-model.trim="$v.registerNumber.$model"
                :class="{
                  'is-invalid': $v.registerNumber.$error,
                  'is-valid': !$v.registerNumber.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">Регистрийн дугаар оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.registerNumber.required"
                  >Регистрийн дугаар оруулна уу.</span
                >
              </div>
            </div>
            <div class="form-group p-field p-col-12 p-md-4">
              <label for="phoneNumber">Утасны дугаар:</label>
              <InputText
                id="phoneNumber"
                type="text"
                class="form-control"
                v-model.trim="$v.phoneNumber.$model"
                :class="{
                  'is-invalid': $v.phoneNumber.$error,
                  'is-valid': !$v.phoneNumber.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">Утасны дугаар оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.phoneNumber.required"
                  >Утасны дугаар оруулна уу.</span
                >
                <span v-if="!$v.phoneNumber.maxLength">
                  Утасны дугаар дээд тал нь
                  {{ $v.phoneNumber.$params.maxLength.max }} тэмдэг байх
                  ёстой.</span
                >
                <span v-if="!$v.phoneNumber.numeric"
                  >Зөвхөн тоон утаг оруулна уу.</span
                >
              </div>
            </div>
             <div class="form-group p-field p-col-12 p-md-4">
              <label for="email">И-мэйл:</label>
              <InputText
                id="email"
                type="text"
                class="form-control"
                v-model.trim="$v.email.$model"
                :class="{
                  'is-invalid': $v.email.$error,
                  'is-valid': !$v.email.$invalid,
                }"
                :disabled="disabled == 1"
                :autofocus="IsParents"
              />
              <div class="valid-feedback">И-мэйл оруулсан!</div>
              <div class="invalid-feedback">
                <span v-if="!$v.email.required"
                  >И-мэйл оруулна уу.</span
                >
                 <span v-if="!$v.email.email"
                  >Э-шуудангын форматыг зөв оруулна уу. / @gmail.com, @yahoo.com
                  /
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          label="Үгүй"
          icon="pi pi-times"
          class="p-button-danger p-button-text"
          @click="actionModal('no', null)"
        />
        <Button
          label="Хадгалах"
          type="submit"
          icon="pi pi-save"
          class="p-button-success"
          @click="actionModal('save', null)"
          v-show="!viewMode && !viewEdit"
        />
        <Button
          label="Шинэчлэх"
          icon="pi pi-save"
          class="p-button-warning"
          @click="actionModal('update', null)"
          v-show="viewEdit"
          :autofocus="viewEdit"
        />
      </template>
    </Dialog>
    <DataTable
      :value="users"
      :filters="filters"
      :paginator="true"
      :rows="5"
      :rowsPerPageOptions="[5, 10, 20]"
      :loading="loading"
      class="p-datatable-sm"
    >
      <template #header>
        <div class="p-grid">
          <div class="p-col">
            <div class="box">
              <Button
                label="Хэрэглэгчийн бүртгэл"
                class="p-button-success"
                icon="pi pi-plus"
                style="margin: 4px 4px 0px 0px"
                @click="actionModal('new', null)"
              />
            </div>
          </div>
          <div class="p-col" style="text-align: right">
            <div class="box">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  placeholder="Хайлт...."
                  size="40"
                  v-model="filters['global']"
                />
              </span>
            </div>
          </div>
        </div>
      </template>
      <template #empty>Хэрэглэгчийн олдсонгүй.</template>
      <template #loading
        >Хэрэглэгчийн мэдээллийг ачаалж байна. Түр хүлээнэ үү.</template
      >
      <Column selectionMode="single" headerStyle="width: 3em"></Column>
      <Column
        field="UserName"
        header="Хэрэглэгчийн нэр"
        headerStyle="width: 10em; text-align: center"
        bodyStyle="text-align: center"
      >
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.UserName }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['UserName']"
              class="p-column-filter p-inputtext-sm"
              placeholder="Нэр-ээр"
              style="width: 10em"
            />
          </div>
        </template>
      </Column>
      <Column
        field="RegisterNumber"
        header="Регистрийн дугаар"
        headerStyle="width: 12em; text-align: center"
        bodyStyle="text-align: center"
      >
        <template #body="slotProps">
          <span class="p-column-title">{{
            slotProps.data.RegisterNumber
          }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['RegisterNumber']"
              class="p-column-filter p-inputtext-sm"
              placeholder="Регистрийн дугаар"
              style="width: 12em"
            />
          </div>
        </template>
      </Column>
      <Column
        field="PhoneNumber"
        header="Утасны дугаар"
        headerStyle="width: 10em; text-align: center"
        bodyStyle="text-align: center"
      >
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.PhoneNumber }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['PhoneNumber']"
              class="p-column-filter p-inputtext-sm"
              placeholder="Утасны дугаар"
              style="width: 10em"
            />
          </div>
        </template>
      </Column>
      <Column
        field="Email"
        header="И-мэйл хаяг"
        headerStyle="width: 10em; text-align: center"
        bodyStyle="text-align: center"
      >
        <template #body="slotProps">
          <span class="p-column-title">{{ slotProps.data.Email }}</span>
        </template>
        <template #filter>
          <div class="sizes">
            <InputText
              type="text"
              v-model="filters['Email']"
              class="p-column-filter p-inputtext-sm"
              placeholder="Имэйл-ээр"
              style="width: 13em"
            />
          </div>
        </template>
      </Column>
      <Column
        headerStyle="width: 25em; text-align: center"
        bodyStyle="text-align: center"
      >
        <template #header>
          <Button type="button" icon="pi pi-cog"></Button> </template
        >,
        <template #body="slotProps">
          <Button
            label="харах"
            type="button"
            icon="pi pi-eye"
            class="p-button-primery"
            style="margin-right: 0.5em"
            @click="actionModal('view', slotProps.data)"
          ></Button>
          <Button
            label="засах"
            type="button"
            icon="pi pi-pencil"
            class="p-button-warning"
            style="margin-right: 0.5em"
            @click="actionModal('edit', slotProps.data)"
          ></Button>
          <Button
            label="устгах"
            type="button"
            icon="pi pi-trash"
            class="p-button-danger"
            @click="actionDialog('open', slotProps.data.Id)"
          ></Button>
        </template>
      </Column>
      <template #footer
        >Нийт {{ users ? users.length : 0 }} хэрэглэгч байна.</template
      >
    </DataTable>
  </div>
</template>

<script>
import axios from "axios";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toast from "primevue/toast";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import { required, maxLength, email, numeric } from "vuelidate/lib/validators";

const baseURL = "http://localhost:8080/user";

export default {
  name: "FormValidation",
  components: {
    DataTable,
    Column,
    Button,
    InputText,
    Toast,
    Dialog,
    Dropdown,
  },
  data() {
    return {
      selectedContractId: "",
      userId: "",
      modalTitle: "",
      users: [],
      errors: [],
      filters: {},
      contractIds: [],
      loading: true,
      displayDelete: false,
      displayModal: false,
      viewMode: false,
      viewEdit: false,
      username: "",
      selectedType: null,
      password: "",
      registerNumber: "",
      phoneNumber: "",
      email:"",
      disabled: 0,
      contractDisabled: 0,
      IsFocus: false,
      IsParents: false,
      open: false,
      typeItems: [
        { name: "Админ", value: "Admin" },
        { name: "Нягтлан бодогч", value: "Accountant" },
        { name: "Хэрэглэгч", value: "User" },
      ],
      rights: ["Admin", "Accountant", "User"],
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
    selectedType: {
      required,
    },
    selectedContractId: {
      required,
    },
    registerNumber: {
      required,
    },
    phoneNumber: {
      required,
      numeric,
      maxLength: maxLength(8),
    },
    email: {
      email,
      required,
    },
  },
  async created() {
    try {
      const requestOne = axios.get(baseURL); //get produts list with Y != IsDeleted
      const requestTwo = axios.get(
        "http://localhost:8080/product/getContractsId"
      ); //get produts list with Y != IsDeleted
      await axios
        .all([requestOne, requestTwo])
        .then(
          axios.spread((...responses) => {
            const responseOne = responses[0];
            const responseTwo = responses[1];
            this.users = responseOne.data;
            this.contractIds = responseTwo.data;
          })
        )
        .catch((errors) => {
          console.log(errors);
        });

      this.loading = false;
    } catch (e) {
      console.error(e);
    }
  },
  methods: {
    formatUnit(value) {
      return value.toLocaleString({ style: "currency" });
    },
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "MNT",
      });
    },
    async actionDialog(condition, id) {
      if (condition == "open") {
        this.userId = id;
        this.displayDelete = true;
      } else {
        if (condition == "yes") {
          // delete contract by Id
          const res = await axios.delete(baseURL + "/" + this.userId);
          if (res.status == 200) {
            const resData = await axios.get(baseURL);
            this.users = resData.data;
            this.$toast.add({
              severity: "error",
              summary: "Амжилттай устгасан",
              detail: "" + this.userId + "",
              life: 3000,
            });
          }
        }
        this.displayDelete = false;
      }
    },
    async actionModal(type, item) {
      if (type == "new") {
        //add new Contract to the database
        this.IsFocus = true;
        this.IsParents = false;
        this.contractDisabled = 0;
        this.disabled = 0;
        this.modalTitle = "Хэрэглэгчийн бүртгэлийн горим";
        this.displayModal = true;
        this.viewEdit = false;
        this.viewMode = false;
        this.username = "";
        this.password = "";
        this.registerNumber = "";
        this.phoneNumber = "";
        this.email = "";
        this.selectedType = null;
        this.selectedContractId = null;
      } else if (type == "save") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        } else {
          const res = await axios.post(baseURL + "/signup", {
            username: this.username,
            password: this.password,
            registerNumber: this.registerNumber,
            phoneNumber: this.phoneNumber,
            email: this.email,
            right: this.selectedType.value,
            contractId: this.selectedContractId.Id,
          });

          if (res.status == 200) {
            const requestOne = axios.get(baseURL); //get contract list with Y != IsDeleted

            await axios
              .all([requestOne])
              .then(
                axios.spread((...responses) => {
                  const responseOne = responses[0];
                  // use/access the results
                  this.users = responseOne.data;
                })
              )
              .catch((errors) => {
                console.log(errors);
              });
            this.modal = false;
            this.displayModal = false;
            this.viewMode = false;
            this.$toast.add({
              severity: "success",
              summary: "Амжилттай хадгалагдсан",
              detail: "",
              life: 3000,
            });
          }
        }
      } else if (type == "view") {
        this.IsFocus = false;
        this.viewEdit = false;
        this.viewMode = true;
        this.contractDisabled = 1;
        this.disabled = 1;
        this.modalTitle = "Хэрэглэгчийн харах горим";
        this.username = item.UserName;
        this.password = item.Password;
        this.registerNumber = item.RegisterNumber;
        this.phoneNumber = item.PhoneNumber;
        this.email = item.Email;
        this.selectedType = this.typeItems.filter(function (type) {
          return type.value.match(item.Rights);
        })[0];
        this.selectedContractId = this.contractIds.filter(function (tmp) {
          return tmp.Id.match(item.ContractId);
        })[0];
         this.displayModal = true;
      } else if (type == "edit") {
        this.IsFocus = false;
        this.viewEdit = true;
        this.viewMode = false;
        this.contractDisabled = 1;
        this.disabled = 0;
        this.modalTitle = "Хэрэглэгчийн засварын горим";
        this.userId = item.Id;
        this.username = item.UserName;
        this.password = item.Password;
        this.registerNumber = item.RegisterNumber;
        this.phoneNumber = item.PhoneNumber;
        this.email = item.Email;
        this.selectedType = this.typeItems.filter(function (type) {
          return type.value.match(item.Rights);
        })[0];
        this.selectedContractId = this.contractIds.filter(function (tmp) {
          return tmp.Id.match(item.ContractId);
        })[0];
        this.displayModal = true;
      } else if (type == "update") {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$toast.add({
            severity: "error",
            summary: "Шаардлагатай талбаруудыг бөглөнө үү",
            detail: "",
            life: 3000,
          });
        } else {
          const res = await axios.put(baseURL + "/" + this.userId, {
            username:  this.username,
            password: this.password,
            registerNumber:  this.registerNumber,
            phoneNumber: this.phoneNumber,
            email: this.email,
            right: this.selectedType.value,
            contractId: this.selectedContractId.Id,
          });
          if (res.status == 201) {
            const resData = await axios.get(baseURL);
            this.users = resData.data;
            this.modal = false;
            this.displayModal = false;
            this.viewMode = false;
            this.$toast.add({
              severity: "warn",
              summary: "Амжилттай шинэчлэгдсэн",
              detail: "" + this.userId + "",
              life: 3000,
            });
          }
        }
      } else this.displayModal = false;
    },
  },
};
</script>